//@ts-nocheck
import * as React from 'react';
import renderHTML from 'react-render-html';

class EmployeeBullets extends React.Component<Props, {}> {

    const bullets = (employment_bullets) => {
        if (employment_bullets != "") {
            return (renderHTML(employment_bullets))
        }
        return <div className="loading">loading <i className="fa fa-spinner"></i></div>
    }

    render() {
        const { total_employees, employment_text, employment_bullets } = this.props;
        //if (total_employees != 0 && employment_bullets !== undefined)
        return (            
                <div className="col-md-9" style={{ paddingTop: "20px" }}>
                    <span>{employment_text}</span><br />

                    {this.bullets(employment_bullets)}
                </div>
            );
        //return (<div></div>)
    }
}

export default EmployeeBullets;